function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { Radio, Skeleton } from 'antd';
import { DeliveryChannel } from '../../enums/delivery-channels';
import { ChannelSwitch } from '../channel-switch/channel-switch';
import { getClassNames } from '../../utils/index';
import { Well } from '../index';
import classNames from 'classnames'; // tslint:disable-next-line:interface-name

var FragmentWrapper = function FragmentWrapper(_) {
  return _.children;
};

export var DeliveryChannelSelector = function DeliveryChannelSelector(props) {
  var _onChange = props.onChange,
      value = props.value,
      titleAppend = props.titleAppend,
      loading = props.loading,
      type = props.type,
      disabledChannels = props.disabledChannels;
  var ComponentWrapper = props.nested === true ? function (_) {
    return /*#__PURE__*/React.createElement(FragmentWrapper, null, _.children);
  } : function (_) {
    return /*#__PURE__*/React.createElement(Well, {
      className: getClassNames('channel-selector', 'nested'),
      title: /*#__PURE__*/React.createElement("span", null, "Delivery Channels", titleAppend ? titleAppend : ''),
      hideFooter: true,
      mode: props.wellMode
    }, /*#__PURE__*/React.createElement(Skeleton, {
      loading: loading,
      active: true,
      avatar: false,
      title: false
    }, /*#__PURE__*/React.createElement(Well, {
      mode: "ghost",
      hideHeader: true,
      hideFooter: true,
      className: classNames(_defineProperty({
        nested: props.wellNested
      }, 'type-2', props.wellNested))
    }, /*#__PURE__*/React.createElement("div", {
      className: "channel-selectors"
    }, _.children))));
  };
  var options = DeliveryChannel.getAllChannels().sort(function (a, b) {
    return a < b ? 1 : -1;
  });
  var disableToggle;

  if ((value === null || value === void 0 ? void 0 : value.length) === 1 && type === 'multiple' && !props.allowEmptySelection) {
    disableToggle = value[0];
  }

  if (disabledChannels !== null && disabledChannels !== void 0 && disabledChannels.length) {
    options = options.filter(function (channel) {
      return disabledChannels.includes(channel);
    });
  }

  if (props.visibleChannels && !props.visibleChannels.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ComponentWrapper, null, type === 'single' && /*#__PURE__*/React.createElement(Radio.Group, {
    disabled: props.disabled,
    size: "small",
    buttonStyle: "solid",
    value: value,
    onChange: function onChange(ev) {
      var channel = ev.target.value;
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(channel);
    }
  }, options.map(function (opt) {
    return /*#__PURE__*/React.createElement(Radio.Button, {
      key: opt,
      value: opt
    }, DeliveryChannel.getLongName(opt));
  })), type === 'multiple' && /*#__PURE__*/React.createElement(React.Fragment, null, options.filter(function (ch) {
    var _props$visibleChannel;

    return (_props$visibleChannel = props.visibleChannels) === null || _props$visibleChannel === void 0 ? void 0 : _props$visibleChannel.includes(ch);
  }).map(function (channel) {
    return /*#__PURE__*/React.createElement(ChannelSwitch, {
      key: channel,
      value: value !== null && value !== void 0 ? value : DeliveryChannel.getAllChannels(),
      channel: channel,
      onChange: props.onChange,
      disabled: (disabledChannels === null || disabledChannels === void 0 ? void 0 : disabledChannels.includes(channel)) || props.disabled,
      disabledToggle: disableToggle === channel,
      iconOptions: {
        showIcon: true
      },
      shortLabelText: props.compact
    });
  })));
};